import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import HrnbContainer, { HrnbRow, HrnbCol } from '../components/controls/HrnbContainer';
import HrnbCard from '../components/controls/HrnbCard';
import HrnbButton from '../components/controls/HrnbButton';
import { useContext } from 'react';
import { CabinetIcon, LoginIcon, RegisterIcon, BattlesIcon, ForumIcon, TrophyIcon } from '../icons';
import UpcomingEventsWidget from '../components/main/UpcomingEventsWidget';
import ActiveBattlesWidget from '../components/main/ActiveBattlesWidget';
import LatestForumWidget from '../components/main/LatestForumWidget';
import '../css/pages/MainPage.css';

const MainPage = () => {
    const navigate = useNavigate();
    const { currentUser } = useContext(UserContext);

    const handleLogin = () => {
        if (currentUser) {
            navigate('/cabinet');
        } else {
            navigate('/login');
        }
    };

    const handleRegister = () => {
        navigate('/register');
    };

    return (
        <div className="main-page">
            {/* Hero Section */}
            <div className="main-page__hero">
                <HrnbContainer>
                    <HrnbRow className="main-page__hero-row">
                        <HrnbCol xs={12} md={6} className="main-page__hero-content">
                            <h1 className="main-page__title">Добро пожаловать в наше сообщество!</h1>
                            <p className="main-page__subtitle">
                                Платформа для проведения баттлов, общения и развития навыков
                            </p>
                            <div className="main-page__actions">
                                <HrnbButton
                                    variant="primary"
                                    size="lg"
                                    onClick={handleLogin}
                                    className="main-page__btn"
                                    icon={currentUser ? <CabinetIcon /> : <LoginIcon />}
                                >
                                    {currentUser ? 'В кабинет' : 'Начать сейчас'}
                                </HrnbButton>
                                {!currentUser && (
                                    <HrnbButton
                                        variant="outline"
                                        size="lg"
                                        onClick={handleRegister}
                                        className="main-page__btn"
                                        icon={<RegisterIcon />}
                                    >
                                        Регистрация
                                    </HrnbButton>
                                )}
                            </div>
                        </HrnbCol>
                        <HrnbCol xs={12} md={6} className="main-page__hero-image">
                            <div className="main-page__hero-placeholder">
                                <span>🚀</span>
                            </div>
                        </HrnbCol>
                    </HrnbRow>
                </HrnbContainer>
            </div>

            {/* Live Dashboard */}
            <div className="main-page__dashboard">
                <HrnbContainer>
                    <h2 className="main-page__section-title">Что происходит</h2>
                    <HrnbRow className="main-page__dashboard-row">
                        <HrnbCol xs={12} md={4}>
                            <UpcomingEventsWidget />
                        </HrnbCol>
                        <HrnbCol xs={12} md={4}>
                            <ActiveBattlesWidget />
                        </HrnbCol>
                        <HrnbCol xs={12} md={4}>
                            <LatestForumWidget />
                        </HrnbCol>
                    </HrnbRow>
                </HrnbContainer>
            </div>

            {/* Features Section */}
            <div className="main-page__features">
                <HrnbContainer>
                    <HrnbRow>
                        <HrnbCol xs={12}>
                            <h2 className="main-page__section-title">Возможности платформы</h2>
                        </HrnbCol>
                    </HrnbRow>
                    <HrnbRow>
                        <HrnbCol xs={12} md={4}>
                            <HrnbCard className="main-page__feature-card">
                                <div className="main-page__feature-icon">⚔️</div>
                                <h3 className="main-page__feature-title">Баттлы</h3>
                                <p className="main-page__feature-description">
                                    Участвуйте в интересных баттлах, соревнуйтесь с другими пользователями и завоёвывайте призовые места
                                </p>
                            </HrnbCard>
                        </HrnbCol>
                        <HrnbCol xs={12} md={4}>
                            <HrnbCard className="main-page__feature-card">
                                <div className="main-page__feature-icon">💬</div>
                                <h3 className="main-page__feature-title">Форум и Чаты</h3>
                                <p className="main-page__feature-description">
                                    Общайтесь с другими участниками, делитесь опытом и находите новых друзей
                                </p>
                            </HrnbCard>
                        </HrnbCol>
                        <HrnbCol xs={12} md={4}>
                            <HrnbCard className="main-page__feature-card">
                                <div className="main-page__feature-icon">🏆</div>
                                <h3 className="main-page__feature-title">Рейтинг и достижения</h3>
                                <p className="main-page__feature-description">
                                    Повышайте свой рейтинг, получайте достижения и становитесь лидером сообщества
                                </p>
                            </HrnbCard>
                        </HrnbCol>
                    </HrnbRow>
                </HrnbContainer>
            </div>

            {/* About Section */}
            <div className="main-page__about">
                <HrnbContainer>
                    <HrnbRow>
                        <HrnbCol xs={12}>
                            <HrnbCard>
                                <h2 className="main-page__section-title">О проекте</h2>
                                <p className="main-page__about-text">
                                    Наша платформа создана для объединения людей с общими интересами.
                                    Здесь вы можете участвовать в баттлах различных форматов, общаться в чатах
                                    и на форуме, делиться своими достижениями и находить единомышленников.
                                </p>
                                <p className="main-page__about-text">
                                    Мы предоставляем удобный интерфейс, современные инструменты для коммуникации
                                    и справедливые правила проведения баттлов. Присоединяйтесь к нашему растущему
                                    сообществу и откройте для себя новые возможности!
                                </p>
                            </HrnbCard>
                        </HrnbCol>
                    </HrnbRow>
                </HrnbContainer>
            </div>

            {/* CTA Section */}
            <div className="main-page__cta">
                <HrnbContainer>
                    <HrnbRow>
                        <HrnbCol xs={12} className="text-center">
                            <h2 className="main-page__cta-title">Готовы начать?</h2>
                            <p className="main-page__cta-text">
                                Регистрация займёт всего пару минут
                            </p>
                            <HrnbButton
                                variant="primary"
                                size="lg"
                                onClick={handleRegister}
                                className="main-page__cta-btn"
                                icon={<RegisterIcon />}
                            >
                                Создать аккаунт
                            </HrnbButton>
                        </HrnbCol>
                    </HrnbRow>
                </HrnbContainer>
            </div>
        </div>
    );
};

export default MainPage;